export default "/images/5bd59961eee2a8172407aea45897e7f9.avif";